module.exports = __webpack_public_path__ + "static/media/double_rounded.17c0409c.svg";